import { isPreview } from './runtime'

const win = window
win.lib = win.lib || {}
const { lib } = win
lib.flexible = lib.flexible || {}

function getDeviceType() {
    const platform = win.device ? win.device.platform : ''
    const { appVersion } = win.navigator
    // 优先使用app插件识别
    const isAndroid = platform ? platform === 'Android' : appVersion.match(/android/gi)
    const isIOS = platform ? platform === 'iOS' : appVersion.match(/iphone/gi)
    return {
        isAndroid,
        isIOS,
    }
}

function parseMeta(metaEl, flexibleEl) {
    let dpr = 0
    let scale = 0
    if (metaEl) {
        const match = metaEl.getAttribute('content').match(/initial-scale=([\d.]+)/)
        if (match) {
            scale = parseFloat(match[1])
            dpr = parseInt(1 / scale, 10)
        }
    } else if (flexibleEl) {
        const content = flexibleEl.getAttribute('content')
        if (content) {
            const initialDpr = content.match(/initial-dpr=([\d.]+)/)
            const maximumDpr = content.match(/maximum-dpr=([\d.]+)/)
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1])
                scale = parseFloat((1 / dpr).toFixed(2))
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1])
                scale = parseFloat((1 / dpr).toFixed(2))
            }
        }
    }

    return {
        dpr,
        scale,
    }
}

function addPlatformClass(docEl, { isAndroid, isIOS }) {
    if (isAndroid) {
        docEl.classList.add('android')
    }

    if (isIOS) {
        docEl.classList.add('ios', 'iphone')
    }
}

function setDprAttribute(docEl, dpr) {
    docEl.setAttribute('data-dpr', String(dpr))
}

function setMetaContent(metaEl, scale) {
    metaEl.setAttribute('content', `initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}, user-scalable=no, viewport-fit=cover`)
}

function rem() {
    const doc = win.document
    const docEl = doc.documentElement
    const flexibleEl = doc.querySelector('meta[name="flexible"]')
    const { flexible } = lib
    const deviceType = getDeviceType()
    let metaEl = doc.querySelector('meta[name="viewport"]')
    let tid
    let { dpr = 0, scale = 0 } = parseMeta(metaEl, flexibleEl)
    if (!dpr && !scale) {
        const { devicePixelRatio } = win
        if (deviceType.isIOS) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3) {
                dpr = 3
            } else if (devicePixelRatio >= 2) {
                dpr = 2
            } else {
                dpr = 1
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1
        }
        scale = 1 / dpr
    }
    addPlatformClass(docEl, deviceType)
    setDprAttribute(docEl, dpr)

    if (!metaEl) {
        metaEl = doc.createElement('meta')
        metaEl.setAttribute('name', 'viewport')
        setMetaContent(metaEl, scale)
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl)
        } else {
            const wrap = doc.createElement('div')
            wrap.appendChild(metaEl)
            doc.write(wrap.innerHTML)
        }
    }

    function refreshRem() {
        let { width } = docEl.getBoundingClientRect()
        if (width / dpr > 540) {
            width = 540 * dpr
        }

        let remVal = (isPreview ? width : 375) / 10
        // 控制 12px 以上
        remVal = remVal >= 37.5 ? remVal : 37.5

        docEl.style.fontSize = `${remVal}px`
        flexible.rem = remVal
        win.rem = remVal
    }

    function refreshDpr(customDpr) {
        const { width } = docEl.getBoundingClientRect()
        customDpr = parseInt(customDpr, 10)
        if (deviceType.isIOS && customDpr !== dpr && customDpr >= 1 && customDpr <= 3) {
            const remVal = (isPreview ? width : 375) / dpr * customDpr / 10
            dpr = customDpr
            scale = 1 / dpr
            flexible.rem = remVal
            flexible.dpr = dpr
            win.rem = remVal
            win.dpr = dpr
            docEl.style.fontSize = `${remVal}px`
            setDprAttribute(docEl, dpr)
            setMetaContent(metaEl, scale)
        }
    }

    win.addEventListener('resize', () => {
        clearTimeout(tid)
        tid = setTimeout(refreshRem, 300)
    }, false)

    win.addEventListener('pageshow', e => {
        if (e.persisted) {
            clearTimeout(tid)
            tid = setTimeout(refreshRem, 300)
        }
    }, false)

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = `${12 * dpr}px`
    } else {
        doc.addEventListener('DOMContentLoaded', () => {
            doc.body.style.fontSize = `${12 * dpr}px`
        }, false)
    }

    refreshRem()

    function rem2px(d) {
        let val = parseFloat(d) * flexible.rem
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px'
        }
        return val
    }

    function px2rem(d) {
        let val = parseFloat(d) / flexible.rem
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem'
        }
        return val
    }

    flexible.dpr = dpr
    win.dpr = dpr
    flexible.refreshRem = refreshRem
    flexible.refreshDpr = refreshDpr
    flexible.rem2px = rem2px
    flexible.px2rem = px2rem
}

rem()

const {
    refreshRem,
    refreshDpr,
    rem2px,
    px2rem,
} = lib.flexible

export {
    refreshRem,
    refreshDpr,
    rem2px,
    px2rem,
}
